<template>
  <div>
    <v-row justify="space-between" no-gutters align="end">
      <v-col cols="auto">
        <div class="mb-1 subtitle-1 font-weight-bold">Additional formats</div>
      </v-col>
    </v-row>
    <v-card outlined tile class="mb-6">
      <v-textarea
        hide-details
        label="Creatives' hashes, separated by comma"
        flat
        tile
        solo
        rows="2"
        v-model="hashes"
        @keydown.enter="addFormats"
      ></v-textarea>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn tile text class="primary" @click.prevent="addFormats">
          Get creatives via hashes
        </v-btn>
      </v-card-actions>
    </v-card>
    <v-card outlined tile class="mb-6" :disabled="!advertiser">
      <v-textarea
        hide-details
        :label="
          !advertiser
            ? `Select advertiser first`
            : `Packages' hashes, separated by comma`
        "
        flat
        tile
        solo
        rows="2"
        v-model="packages"
        @keydown.enter="addFormatsViaPackage"
      ></v-textarea>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn tile text class="primary" @click.prevent="addFormatsViaPackage">
          Get creatives via packages hashes
        </v-btn>
      </v-card-actions>
    </v-card>
    <BannerAdditionalFormat
      outlined
      tile
      v-for="(banner, i) in localBanners"
      :key="banner.live"
      class="mb-4"
      v-model="localBanners[i]"
      :subcampaigns="subcampaigns"
      :offers="offers"
      @delete="onDelete(i)"
      @update="onUpdate($event, i)"
    />
  </div>
</template>

<script>
import Vue from "vue";
import axios from "axios";

export default Vue.extend({
  name: "BannerFormat",
  components: {
    BannerAdditionalFormat: () =>
      import("@/components/Dashboard/BannerAdditionalFormat"),
  },
  data() {
    return {
      localBanners: [],
      hashes: "",
      hashList: [],
      packages: [],
    };
  },
  props: ["advertiser", "value", "subcampaigns", "offers", "hash"],
  methods: {
    updateModel() {
      this.$emit("input", this.localBanners);
    },
    onUpdate(e, i) {
      this.localBanners[i] = e;
      this.updateModel();
    },
    onDelete(id) {
      this.localBanners.splice(id, 1);
      this.updateModel();
    },
    addFormat() {
      this.localBanners.push({
        filename: "",
        live: "",
        file: null,
        active: true,
        dialogDelete: false,
      });
      this.updateModel();
    },
    async addFormatsViaPackage() {
      if (this.advertiser?.hash) {
        const advertiserHash = this.advertiser.hash;
        const packagesHash = this.packages.trim();
        this.packages = "";
        try {
          const offers = this.offers ? `&${this.offers}` : "";
          const {
            data,
          } = await axios(
            `https://creatives-preview.rtbhouse.com/api/packs/${advertiserHash}/${packagesHash}`,
            { offers, disable_redirect_preview: false }
          );
          let filteredBanners = data.data;
          if (this.hash.length < 1) {
            filteredBanners = data.data.filter((b) => {
              if (b.previews[0].width == 300 && b.previews[0].height == 600) {
                this.$emit("updateHash", b.hash);
                return false;
              }
              return true;
            });
          } else {
            filteredBanners = data.data.filter((b) => {
              return !b.previews[0].previewUrl.endsWith(this.hash);
            });
          }
          filteredBanners.length = Math.min(filteredBanners.length, 6);
          const hashList = filteredBanners.map((b) => b.hash);
          const tempBanners = [...new Set([...hashList])].map((x) => {
            return { hash: x.trim() };
          });

          const finalFilteredBanners = tempBanners.filter(
            (tb) => !this.value.find((v) => v.hash === tb.hash)
          );

          this.localBanners = [...this.value, ...finalFilteredBanners];

          this.hashes = "";
          this.updateModel();
        } catch (error) {
          console.log(error);
        }
      }
    },
    addFormats() {
      if (this.hashes == "") {
        this.hashList = [];
        return;
      }
      const hashList = this.hashes.split(",");

      const tempBanners = [...new Set([...hashList])].map((x) => {
        return { hash: x.trim() };
      }, this.value);

      const filteredBanners = tempBanners.filter(
        (tb) => !this.value.find((v) => v.hash === tb.hash)
      );
      this.localBanners = [...this.value, ...filteredBanners];
      this.hashes = "";
      this.updateModel();
      //   this.formatsList = [...new Set([...this.packsList, ...this.hashList])];
    },
  },
  mounted() {
    if (this.value) this.localBanners = this.value;
  },
});
</script>

<style></style>
